import { render, staticRenderFns } from "./entertestresults.vue?vue&type=template&id=165edfd2"
import script from "./entertestresults.vue?vue&type=script&lang=js"
export * from "./entertestresults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports